import { ContentDetail } from '../components/content/ContentDetail';

export function ContentDetailPage() {
  return <ContentDetail />;
}
